const features = [
  {
    title: "Accounting",
    desc: "Track income, expenses, and manage your books with built-in financial reporting and bank reconciliation.",
    icon: "/images/erp/accounting.jpg",
  },
  {
    title: "Inventory Management",
    desc: "Maintain stock levels, track item movements, and manage warehouses across multiple locations.",
    icon: "/images/erp/inventory.jpg",
  },
  {
    title: "Sales & CRM",
    desc: "Manage leads, quotations, and sales orders while nurturing customer relationships through CRM tools.",
    icon: "/images/erp/sales-crm.jpg",
  },
  {
    title: "Purchasing",
    desc: "Simplify supplier management, purchase orders, and material requests with automated workflows.",
    icon: "/images/erp/purchase.jpg",
  },
  {
    title: "Human Resources",
    desc: "Manage employee records, attendance, leaves, appraisals, and payroll in one place.",
    icon: "/images/erp/hr.jpg",
  },
  {
    title: "Projects",
    desc: "Track tasks, time logs, project progress, and billing with powerful project management tools.",
    icon: "/images/erp/projects.jpg",
  },
  {
    title: "Manufacturing",
    desc: "Plan production, manage bill of materials (BOM), and track job cards and work orders efficiently.",
    icon: "/images/erp/manufacturing.jpg",
  },
  {
    title: "Asset Management",
    desc: "Track acquisition, depreciation, and maintenance schedules of your company assets.",
    icon: "/images/erp/assets.jpg",
  },
  {
    title: "Support Helpdesk",
    desc: "Handle customer support tickets and service level agreements (SLAs) with ease.",
    icon: "/images/erp/helpdesk.jpg",
  },
  {
    title: "Website & Ecommerce",
    desc: "Create your website or online store directly from Ethos ERP, with product catalogs and shopping cart support.",
    icon: "/images/erp/website.jpg",
  },
  {
    title: "Analytics & Dashboards",
    desc: "View real-time dashboards and customized reports for smart business decisions.",
    icon: "/images/erp/analytics.jpg",
  },
  {
    title: "Integrations & APIs",
    desc: "Connect Ethos ERP with other systems via REST APIs, webhooks, or integrations like Shopify, PayPal, and more.",
    icon: "/images/erp/integrations.jpg",
  },
];

export function ERPModules() {
  return (
    <div className="py-12">
      <h2 className="text-3xl font-bold text-center mb-12">ERP Features</h2>

      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
        {features.map((feature, i) => (
          <div
            key={i}
            className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
          >
            <div
              className="h-48 bg-cover bg-center"
              style={{ backgroundImage: `url(${feature.icon})` }}
            ></div>
            <div className="p-6">
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-600">{feature.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
